import { motion } from 'framer-motion'
import { ArrowDownRight } from 'lucide-react'

const EASE = [0.16, 1, 0.3, 1]

const PRINCIPLES = [
  { id: 'simple', word: 'Simple', note: 'Nothing unnecessarily complicated.', tint: '#CBD8E9' },
  { id: 'portioned', word: 'Portioned', note: 'Designed around sensible everyday portions.', tint: '#FDEFB2' },
  { id: 'real', word: 'Real', note: 'Made for real routines, real hunger and real life.', tint: '#FADCC8' },
]

function Row({ p, i }) {
  return (
    <motion.li
      initial={{ opacity: 0, y: 34 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.4 }}
      transition={{ duration: 0.9, ease: EASE, delay: i * 0.12 }}
      className="group relative flex cursor-default items-center justify-between gap-6 border-b border-[var(--line)] py-10 transition-colors duration-500 first:border-t hover:border-transparent md:py-14"
      data-testid={`principle-${p.id}`}
    >
      <div
        className="absolute inset-0 origin-bottom scale-y-0 transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-y-100"
        style={{ background: p.tint, opacity: 0.5 }}
        aria-hidden="true"
      />
      <div className="relative flex items-baseline gap-5 pl-1 md:gap-10 md:pl-4">
        <span className="eyebrow !text-ink/50">0{i + 1}</span>
        <span className="display-l">{p.word}</span>
      </div>
      <div className="relative flex items-center gap-6 pr-1 text-right md:pr-6">
        <p className="hidden max-w-[24ch] text-[0.95rem] leading-snug text-haze sm:block">{p.note}</p>
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[var(--line)] transition-all duration-500 group-hover:rotate-0 group-hover:bg-ink group-hover:text-paper sm:rotate-45">
          <ArrowDownRight size={16} />
        </span>
      </div>
      <p className="relative px-1 text-[0.9rem] text-haze sm:hidden">{p.note}</p>
    </motion.li>
  )
}

export default function Principles() {
  return (
    <section className="px-6 py-20 md:px-10 md:py-32" data-testid="principles-section">
      <div className="mx-auto max-w-6xl">
        <motion.p {...{ initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true }, transition: { duration: 1 } }} className="eyebrow mb-10 pl-1">
          What we're made of
        </motion.p>
        <ul>
          {PRINCIPLES.map((p, i) => (
            <Row key={p.id} p={p} i={i} />
          ))}
        </ul>
      </div>
    </section>
  )
}
